import React from 'react'

function TenderTextQSRQSL() {
  return (
    <embed src="\pdfs\EAT1.6.3_Q-SR-Q-SL_Step_displacement_outlets_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextQSRQSL